import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 22 25"
    {...props}
  >
    <path
      fill="#787887"
      d="M15.172 14.583c3.469 0 6.328 2.86 6.328 6.328v1.172a2.25 2.25 0 0 1-2.25 2.25H2.75a2.22 2.22 0 0 1-2.25-2.25v-1.172c0-3.468 2.813-6.328 6.281-6.328 1.36 0 1.97.75 4.22.75 2.202 0 2.812-.75 4.171-.75m4.078 7.5v-1.172a4.08 4.08 0 0 0-4.078-4.078c-.703 0-1.781.75-4.172.75-2.437 0-3.516-.75-4.219-.75-2.25 0-4.03 1.828-4.03 4.078v1.172zM11 13.833c-3.75 0-6.75-3-6.75-6.75 0-3.703 3-6.75 6.75-6.75 3.703 0 6.75 3.047 6.75 6.75 0 3.75-3.047 6.75-6.75 6.75m0-11.25c-2.484 0-4.5 2.063-4.5 4.5 0 2.485 2.016 4.5 4.5 4.5 2.438 0 4.5-2.015 4.5-4.5 0-2.437-2.062-4.5-4.5-4.5"
    />
  </svg>
);
export default SvgUserIcon;
